import type { DataTableColumn } from '@/components/custom/erp';
import type { PhuongTienVanChuyen } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<PhuongTienVanChuyen>[] => [
  {
    field: 'ma_ptvc',
    headerName: 'Mã phương tiện',
    width: 150
  },
  {
    field: 'ten_ptvc',
    headerName: 'Tên phương tiện',
    width: 250
  }
];
